import type { ReactNode } from 'react';
import styles from './interior.module.css';

interface SourcesPanelProps {
  id?: string;
  heading?: string;
  children: ReactNode;
}

/** The caller retains source order, anchors, link attributes and provenance. */
export function SourcesPanel({
  id = 'sources',
  heading = 'Sources',
  children,
}: SourcesPanelProps): React.ReactElement {
  return (
    <section id={id} aria-labelledby={`${id}-heading`} className={styles.sources}>
      <h2 id={`${id}-heading`}>{heading}</h2>
      {children}
    </section>
  );
}
